/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLPublicContactsService, MLAddressVerificationService } from 'gw-capability-quoteandbind';
import { MLBundleService, MLMultiLobsDataHolderService, MLRiskAnalysisService } from 'ml-services-common-react';
import { MLAddressDetailsComponent, MLPhoneNumberComponent, MLScriptComponent, MLModifierComponent } from 'ml-components-common-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLModalService } from 'ml-portals-services-react';
import { MLDisclosureUtil, MLErrorMessageUtil, MLProductCodeUtil } from 'ml-portals-util-js';
import { QuestionSetComponent, FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLWizardNavUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import { MLUWIssuesPanelComponent } from "gw-capability-gateway-quoteandbind-common-react";
import { EmailValidationService } from 'gw-capability-quoteandbind';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';

import { UserService } from 'gw-capability-gateway';
import { LoadSaveService as GatewayLoadSaveService } from "gw-capability-gateway-quoteandbind";
import { LoadSaveService as QnBLoadSaveService } from 'gw-capability-quoteandbind';
import { ScrollToError } from '@jutro/legacy/wizard-next';

import metadata from './HOAdditionalInformationPreBind.metadata.json5';
import messages from './HOAdditionalInformationPreBind.messages';
import MLInspectionKeyRemindersMetadata from '../MLInspectionKeyRemindersModal/MLInspectionKeyRemindersModal.metadata.json5';
import MLInspectionKeyRemindersModal  from '../MLInspectionKeyRemindersModal/MLInspectionKeyRemindersModal';
import EsignatureComponent from 'gw-capability-quoteandbind-common-react/components/EsignatureComponent/EsignatureComponent';

const HO_ADDITIONAL_INTERESTS_PATH = 'lobData.homeowners.coverables.additionalInterests';
const ADDITIONAL_INTEREST_SUBTYPE = 'HOPDwellAddlInterest';
const QUOTE_DETAILS = 'quoteDetails';

const questionsToHide = ['HOPOccupationType_Ext', 'HOPEducationLevel_ML', 'HOPCoverageAdditionalInfo_ML', 'HOPRentHome_ML',
    'HOPBusinessHome_ML', 'HOPHasTrampoline_ML', 'HOPBusinessPursuitsCoverage_ML', 'HOPOwnPropertyDiffLocation_ML', 'HOPRentMoreThan30DaysPerYear_ML',
    'HOPSubscriptionPayments_ML',"HOPDwelllingHomeSharing_Ext","HOPDwellingHomeSharingAirbnb_Ext"];

const _filterQuestionSet = (qs) => {
    qs.answers = Object.keys(qs.answers)
        .filter((key) => !questionsToHide.includes(key))
        .reduce((obj, key) => {
            obj[key] = qs.answers[key];

            return obj;
        }, {});
};

function HOAdditionalInformationPreBindPage(props) {
    const { wizardData: submissionVM, updateWizardData, goNext, steps, history } = props;
    const isGpa = appConfig.portalCode === 'GPA';
    const isQnB = appConfig.portalCode === 'QB';

    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate, isComponentValid } = useValidation('AdditionalInformationPreBindPage');
    const LoadSaveService = (isGpa) ? GatewayLoadSaveService : QnBLoadSaveService;
    const modalApi = useModal();

    const { bindData } = submissionVM;
    const coveragePartTypeML = submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code
    const additionalInterests = _.get(submissionVM, HO_ADDITIONAL_INTERESTS_PATH);
    const emailVerification = bindData.contactEmail;
    const primaryNamedInsuredName = submissionVM.baseData.primaryNamedInsured_ML.displayName.value;
    const primaryNamedInsuredVM = submissionVM.baseData.primaryNamedInsured_ML;
    const addressVM = submissionVM.baseData.policyAddress;
    const isCompRaterPolicy = submissionVM.value.isCompRater();
    const isRenters = submissionVM.value.isRenters();
    const isLandLord = submissionVM.value.isLandlordHome() || submissionVM.value.isLandlordCondo();
    const isDwelling = submissionVM.value.isDwelling();
    const isLandlordHome = submissionVM.value.isLandlordHome();
    const isBundle = submissionVM.isBundle_ML.value;
    const quoteID = submissionVM.quoteID.value;

    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);

    const [potentialContacts, updatePotentialContacts] = useState([]);
    const [showErrors, updateShowErrors] = useState(false);
    const [potentialContactsLoading, updatePotentialContactsLoading] = useState(true);
    const [scriptML, updateScriptML] = useState([]);
    const [reEnterEmail, updateReEnterEmail] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [additionalInterestAvailableCandidatesML, setAdditionalInterestAvailableCandidatesML] = useState([]);

    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);

    const [selectedInspectionMethodCode, setSelectedInspectionMethodCode] = useState('');

    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isHome = submissionVM.value.isHomeOwners()
    
    const isModernProductHO = isModernProduct && isHome;
    const isContinueClickedRef =  useRef(false);
     const multipolicyLobCodes = [
        'HOPMultiPolicyNumberAuto_Ext',
        'HOPAnotherPrimSeasSecPropertyPolicyNumber_Ext',
        'HOPPrimSeasSecPropertyPolicyNumber_Ext',
        'HOPMultiPolicyNumberLandlord_Ext',
        'HOPMultiPolicyNumberUmbrella_Ext',
        'HOPMultiPolicyNumberBoat_Ext',
        'HOPMultiPolicyNumberMotorcycle_Ext',
        'HOPMultiPolicyNumberRecreationalVehicle_Ext',
        'HOPMultiPolicyNumberOffRoadVehicle_Ext'
    ];
    const HO_MODIFIER_PATH = "lobData.homeowners.modifiers_ML";
    const hoModifiers = _.get(submissionVM, HO_MODIFIER_PATH);
    

    const {nextStepVisited} = MLWizardNavUtil(props);

    // inspection call
    const [inspection, setInspection] = useState({});
    const updateInProgress = useRef(false);


    const updateInspection = (data) => {
        if (!_.isEmpty(data)) {
            setInspection({
                inspectionStatus: data.inspectionStatus,
                orderedDate: data.orderedDate,
                returnedDate: data.returnedDate,
                type: data.type,
                inspectionTypeCode: data.inspectionTypeCode,
                propCommGated: data.propCommGated,
                company: data.company,
                replacementCost: data.replacementCost,
                isPolicyBound: data.isPolicyBound,
                hasHomeInspectionBeenCompleted: data.hasHomeInspectionBeenCompleted,
                inspectionHelp: (data.type === 'Exterior-Only Onsite' || data.type === 'Exterior-Only Self-Survey') ? 'Exterior Only' : data.type,
                propertyDirections: data.propertyDirections
            });

            const clonedSubVM = viewModelService.clone(submissionVM);

            _.set(clonedSubVM, 'bindData.value.homeInspectionDetails_Ext.inspectionTypeCode', data.inspectionTypeCode);
            _.set(clonedSubVM, 'bindData.value.homeInspectionDetails_Ext.propCommGated', data.propCommGated);
            _.set(clonedSubVM, 'bindData.value.homeInspectionDetails_Ext.propertyDirections', data.propertyDirections);
            updateWizardData(clonedSubVM);

            setSelectedInspectionMethodCode(data.inspectionTypeCode)

        }
    };

    hoModifiers.lineModifiers_ML.value.forEach((mod, index, arr) => {
      const isYes = mod.chosenTermValue === true;

      mod.savedFromPortal = true;
      mod.updated = true;
      mod.editMode_ML = true;
      mod.isVisible_ML = true;

      if (mod.hasDependentModifier_ML) {
        const dependentMod = arr[index + 1];

        if (dependentMod && multipolicyLobCodes?.includes(dependentMod.codeIdentifier_ML)) {
          dependentMod.isVisible_ML = isYes;
          dependentMod.isInputValueRequired_ML = false;
          dependentMod.updated = true;

          if (!isContinueClickedRef.current &&
            (dependentMod.chosenTermValue === "ManualMPD" ||
            dependentMod.chosenTermValue === "ManualMP")
          ) {
            dependentMod.chosenTermValue = "";
          }

          const baseName =
            dependentMod.name?.replace(" (optional)", "") ||
            "Please enter your policy number";
          dependentMod.name = `${baseName} (optional)`;
        }
      }
    });

    const isEnableEsign_State = _.get(submissionVM,'enableEsign_State.value','')
    const userState = _.get(submissionVM, 'baseData.policyAddress.state.value.code','')
    const isEsignEnabledForState = isEnableEsign_State.split(',').map(state => state.trim()).includes(userState);
 

    const getAndSetInspectionByJobNumber = (submissionNumber) => {
        if (_.isEmpty(inspection)) {
            const promise = MLRiskAnalysisService.getRAHomeInspectionDetailsMLByJobNumber(submissionNumber, authHeader);

            promise.then((data) => {
                updateInspection(data.lobs.homeowners.homeInspection);
            }, () => {
                setInspection({});
            });
        }
    };

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        addWarningAlert,
        addErrorAlert,
        clearBlockAlerts,
        getNumberOfAlerts
    } = MLNotificationBlockUtil();

    useEffect(() => {
        if (isGpa) {
            UserService.getCurrentUser(authHeader).then((user) => {
                HOTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Ho AdditionalInfo Prebind Page'});
            });
        } else {
                HOTrackEvent('Issuance Step Reached', false, submissionVM, null, { step: 'Ho AdditionalInfo Prebind Page'}, true);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        MLPublicContactsService.getMortgageeContacts(isGpa && authHeader).then((data) => {
            updatePotentialContacts(data);
        }).finally(() => updatePotentialContactsLoading(false));

        LoadSaveService.getAdditionalInterestCandidatesML(submissionVM.quoteID.value, authHeader).then((candidates) => {
            setAdditionalInterestAvailableCandidatesML(candidates);
        });

        const canSkipSave = steps.some((step) => step.mlStepName === 'paymentDetails' && !!step.visited);
        if (!canSkipSave) {
            const clonedSubmissionVM = viewModelService.clone(submissionVM);
            _.set(clonedSubmissionVM, 'lobData.homeowners.coverables.addInterestTypeCategory', ADDITIONAL_INTEREST_SUBTYPE);
            updateWizardData(clonedSubmissionVM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isDwelling || isLandlordHome) {
            LoadSaveService.sendHomeInspectionOrder(submissionVM.quoteID.value, authHeader).then((res) => {
                if (res) {
                    getAndSetInspectionByJobNumber(submissionVM.quoteID.value)
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGpa) {
            LoadSaveService.getScript(QUOTE_DETAILS, { quoteID: submissionVM.quoteID.value }, authHeader)
                .then((lines) => {
                    updateScriptML(lines);
                });

            if (!_.get(submissionVM, 'bindData.contactEmail.value') &&
                _.get(submissionVM, 'quoteData.offeredQuotes.value[0].commPreference_ML') === 'paper') {
                bindData.value.reEnterEmailRequired_ML = false;
                updateReEnterEmail(false);
            } else {
                bindData.value.reEnterEmailRequired_ML = true;
                updateReEnterEmail(true);
            }
            updateScriptML(submissionVM.script_ML.value);
            if (submissionVM.isBundle_ML.value) {
                const prefillFrom = MLBundleService.getPrefillEmailCandidate(authHeader);
                if (prefillFrom) {
                    emailVerification.value = prefillFrom.emailAddress;
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Force the user to re-enter the email by clearing the field on init.
     * @param emailVerification - contact email View Model who's email we want to initialize.
     */
    useEffect(() => {
        if (!isGpa) {
            _.set(submissionVM, 'bindData.value.reEnterEmailRequired_ML', true);
            if (isBundle) {
                const prefillFrom = MLBundleService.getPrefillEmailCandidate(authHeader);
                if (prefillFrom) {
                    emailVerification.value = prefillFrom.emailAddress;
                }
            }

            if (!isBundle && emailVerification !== undefined && !isQnB) {
                // eslint-disable-next-line no-param-reassign
                emailVerification.value = '';
            }
        }
        _.set(submissionVM, 'baseData.value.originalEmail', _.get(submissionVM, 'bindData.contactEmail.value'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!_.get(submissionVM, '_context.Binding', false)) {
            const vm = viewModelService.changeContext(submissionVM, {
                Binding: true
            });
            updateWizardData(vm);
        }
    }, [submissionVM, updateWizardData, viewModelService]);

    const writeValue = useCallback((value, path) => {
        setDisableNextButton(false);
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const updateAddressVM = () => {
        refreshData();
    };

    const shouldShowAnimalQs = () => {
        const animalSelected = _.get(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualAnimals_Ext', false);
        const animalType = _.get(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers.HOPPreQualAnimalsType_Ext', undefined);
        if (animalSelected && !_.isUndefined(animalType) && animalType === "HOPPreQualAnimalsTypeDomestic_Ext" || animalType === "HOPPreQualAnimalsTypeBoth_Ext") {
            return true;
        }
        return false;
    };

    const sortAdditionalInterests_Ext = () => {
        const additionalInterestVM = _.get(submissionVM, 'lobData.homeowners.coverables.additionalInterests.value', []);
        const sortedInterests = _.sortBy(additionalInterestVM, (interest) => {
            if (interest.publicID) {
                return _.toInteger(interest.publicID.split(':')[1]);
            }
            return undefined;
        });
        _.set(submissionVM, 'lobData.homeowners.coverables.additionalInterests.value', sortedInterests);
    };

    const hasAnyNonApprovedUwIssue = (allUwIssues) => {
        if (allUwIssues && allUwIssues.length > 0) {
            return allUwIssues.some(elem => elem.hasApprovalOrRejection === false && elem.initialBlockingPoint_ML !== 'NonBlocking')
        }

        return false;
    };

    const checkForHomeAdditionalInfoPreBindUwIssues = () => {
        // get the selected quote version
        const selectedVersion = _.get(submissionVM, 'bindData.value.chosenQuote', "");
        // get the offering object for the selected version from offeredQuotes
        const offeringObj = _.find(_.get(submissionVM, 'quoteData.value.offeredQuotes', ""), { publicID: selectedVersion });
        // get the uwIssues_ML from the offering object
        const uwIssues = offeringObj?.uwIssues_ML;

        if (uwIssues?.length > 0 && hasAnyNonApprovedUwIssue(uwIssues)) {
            setIsUWIssuesPanelVisible(true);
            setBlockingUwIssues(uwIssues);
            setDisableNextButton(true);

            return true;
        }

        setDisableNextButton(false);

        return false;

    }

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0 && hasAnyNonApprovedUwIssue(issues)) {
            setDisableNextButton(true);
        } else {
            setDisableNextButton(false);
        }
    }, []);

    const dwellingInfoQuestionSetData = _.get(submissionVM.lobData.homeowners, 'dwellingAdditionalInfo.value[0]');
    const filteredDwellingInfoQuestionSetData = _.clone(dwellingInfoQuestionSetData);

    if (filteredDwellingInfoQuestionSetData) {
        _filterQuestionSet(filteredDwellingInfoQuestionSetData);
    }

    const _showAnimalExclusionWarningMessage = () => {
  const alertKey = "HOPLocationAnimalExclusionWarning";
 
  const animalYes =
    filteredDwellingInfoQuestionSetData.answers.HOPHasAnimal_ML === true ||
    filteredDwellingInfoQuestionSetData.answers.HOPHasAnimal_ML === "true";
 
  const exoticYes =
    filteredDwellingInfoQuestionSetData.answers.HOPHasExoticAnimal1_ML === true ||
    filteredDwellingInfoQuestionSetData.answers.HOPHasExoticAnimal1_ML === "true";
 
  const shouldShow = isQnB && animalYes && exoticYes;
 
  if (shouldShow) {
    if (getNumberOfAlerts(alertKey) <= 0) {
      addWarningAlert(messages.showAnimalExclusionWarningMessage, alertKey);
      window.scrollTo(0, 0);
    }
  } else {
    clearBlockAlerts(alertKey);
  }
};

    useEffect(() => {
  _showAnimalExclusionWarningMessage();
}, [isQnB,filteredDwellingInfoQuestionSetData.answers.HOPHasAnimal_ML,filteredDwellingInfoQuestionSetData.answers.HOPHasExoticAnimal1_ML]);

    const checkQuestionSetSync = (serviceCall) => {
        let updatePromise;

        if (questionSetSyncing && questionSetSyncPromise) {
            // console.log("Waiting for questionSetSyncing to finish...")
            updatePromise = questionSetSyncPromise.then(() => {
                const promise = serviceCall();

                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingQuestions, promise, true);
                }, 0);

                return promise;
            });
        } else {
            updatePromise = serviceCall();
            setTimeout(() => {
                showProgressDialog(platformMessages.syncingQuestions, updatePromise, true);
            }, 0);
        }

        setQuestionSetSyncing(true);
        setQuestionSetSyncPromise(updatePromise);

        return updatePromise;
    };

    // const checkOwnsResidenceModifier = (mod, copiedView) => {
    //     if (mod.patternCode.value === "z70hmvhmucbde2eo899j9kmgjdb") {
    //       if (mod.chosenTermValue.value) {
    //         if (
    //           !copiedView.lobData.personalAuto.modifiers_ML
    //             .yearsAtCurrentResidence
    //         ) {
    //           copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence = 0;
    //         }
    //       }
    //     }
    //   };

    const syncModifiers = (submissionData, mlModifier) => {
       submissionData.forEach((mod) => {
         const oldMod = mlModifier.value.find((value) => {
           return value.patternCode === mod.patternCode;
         });
         _.set(mod, "chosenTermValue", oldMod ? oldMod.chosenTermValue : null);
         if (mod.valueType === "boolean") {
           _.set(mod, "chosenTermValue", oldMod ? oldMod.chosenTermValue : false);
         }
         if (!multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
           _.set(mod, "savedFromPortal", true);
           _.set(mod, "editMode_ML", true);
         }
       });
       _.set(mlModifier, "value", submissionData);
     };

//      const syncModifierDependentQuestions = (submissionData, mlModifier) => {
//      if (mlModifier.yearsAtCurrentResidence) {
//        mlModifier.yearsAtCurrentResidence.value =
//          submissionData.yearsAtCurrentResidence;
//      }
//    };

     const updateAdditionalInfoPrebindModifier = async (mod) => {
            const codeIdentifier = _.get(mod, 'codeIdentifier_ML.value') || _.get(mod, 'codeIdentifier_ML');
            const enteredValue = _.get(mod, 'chosenTermValue.value') ?? _.get(mod, 'chosenTermValue');
            const isPolicyNumberModifier = multipolicyLobCodes.includes(codeIdentifier);
            const isBlankPolicyNumber = isPolicyNumberModifier && ( enteredValue === undefined || enteredValue === null || String(enteredValue).trim() === '' );
         if (isPolicyNumberModifier) {
             _.set(mod, 'chosenTermValue.value', isBlankPolicyNumber ? '' : enteredValue);
             _.set(mod, 'isInputValueRequired_ML.value', false);
             _.set(mod, 'editMode_ML.value', true);
             _.set(mod, 'savedFromPortal.value', true);
             _.set(mod, 'updated.value', true);
     
         } else {
             _.set(mod, "updated.value", true);
         }
             const validMods = [];
             const copiedModel = viewModelService.clone(submissionVM);
     
             for (let i = 0; i < hoModifiers.lineModifiers_ML.length; i += 1) {
               const modifier = hoModifiers.lineModifiers_ML.children[i];
               //checkOwnsResidenceModifier(modifier, copiedModel);
               const modifierCode = _.get(modifier, 'codeIdentifier_ML.value') || _.get(modifier, 'codeIdentifier_ML');
               const isPolicyNumber = multipolicyLobCodes.includes(modifierCode);
                if (isPolicyNumber || modifier.aspects.subtreeValid) {
                 validMods.push(modifier.value);
               }
             }
         _.set(
             copiedModel,
             "lobData.homeowners.modifiers_ML.lineModifiers_ML",
             validMods,
         );

         if (updateInProgress.current) {
             return;
         }
         updateInProgress.current = true;
      
     
             const updateModifiersPromise = checkQuestionSetSync(() =>
               LoadSaveService.updateModifiers(copiedModel.value, authHeader),
             );
     
             updateModifiersPromise
               .then((submissionData) => {
                 syncModifiers(
                   submissionData.lobData.homeowners.modifiers_ML.lineModifiers_ML,
                   hoModifiers.lineModifiers_ML,
                 );
                 syncModifierDependentQuestions(
                   submissionData.lobData.homeowners.modifiers_ML,
                   hoModifiers,
                 );
                 hoModifiers.lineModifiers_ML.children.forEach((modifier) => {
                   const modifierCode =
                     _.get(modifier, "codeIdentifier_ML.value") ||
                     _.get(modifier, "codeIdentifier_ML");
     
                   if (multipolicyLobCodes.includes(modifierCode)) {
                     _.set(modifier, "isInputValueRequired_ML.value", false);
                   }
                 });
      
                 updateWizardData(submissionVM);
               })
               .catch((e) => {
                 console.error(e);
               });
           };

    const syncDwellingInfoQuestionSets = (qsQuestionType, questionSetToSync = filteredDwellingInfoQuestionSetData) => {
        setDisableNextButton(false);

        const syncPromise = checkQuestionSetSync(() => LoadSaveService.syncQuestionSetML(quoteID, [questionSetToSync], authHeader));

        syncPromise.then((updatedQuestionSets) => {
            const dwellingQs = updatedQuestionSets.find((q) => q.code === 'HOPDwellingAddlInfo_ML');

             _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', dwellingQs);
             _showAnimalExclusionWarningMessage();
                refreshData();
        });
    };

    const onChangeTypes = ['Boolean', 'Choice', 'Integer'];
    const animalDependentKeyPrefixes = [
    'HOPHasDog',
    'HOPDog',
    'HOPHasExoticAnimal',
    'HOPExoticAnimal',
    'HOPHasFarmAnimals',
    'HOPHasOtherAnimals',
    'HOPDogBreed',
    'HOPDogBirthYear'
    ];

  const isAnimalDependentAnswerKey = (answerKey = '') => {
    if (answerKey === 'HOPHasAnimal_ML') {
        return false;
    }

    return animalDependentKeyPrefixes.some((prefix) => answerKey.startsWith(prefix));
   };

   const resetAnimalDependentAnswers = (questionSet) => {
    const answers = _.get(questionSet, 'answers', {});

        Object.keys(answers).forEach((answerKey) => {
        if (!isAnimalDependentAnswerKey(answerKey)) {
            return;
        }

        const currentValue = answers[answerKey];

        // Keep boolean/radio-style answers defaulted to "No"; clear all other answer types
        if (_.isBoolean(currentValue) || currentValue === 'true' || currentValue === 'false') {
            _.set(questionSet, 'answers.' + answerKey, 'false');
        } else {
            _.unset(questionSet, 'answers.' + answerKey);
        }
        });
   };

   const onDwellingInfoValueChange = (aQuestionSetAnswersValue, pathToAnswers, qsQuestionType) => {
    const nextQs = _.cloneDeep(aQuestionSetAnswersValue || {});
    const hasAnimal = _.get(nextQs, 'answers.HOPHasAnimal_ML');

    // When "Do you have any animals?" is set to No, wipe all dependent animal answers
    if (hasAnimal === false || hasAnimal === 'false') {
        resetAnimalDependentAnswers(nextQs);
    }

    _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', nextQs);

    if (onChangeTypes.includes(qsQuestionType)) {
        // RadioButton has no onBlur event
        syncDwellingInfoQuestionSets(qsQuestionType, nextQs);
    } else {
        refreshData();
    }
  };

    const onBlur = (evt, object, qsQuestionType) => {
        // check if progress dialog is causing the onBlur event and if so, do not trigger another sync call
        const isTargetModal = evt?.relatedTarget?.className?.indexOf('ml-modal-loading') > -1;

        if (!onChangeTypes.includes(qsQuestionType) && !isTargetModal) {
            // DropdownField component triggers onBlur event but syncQuestionSet should be performed in onValueChange
            syncDwellingInfoQuestionSets(qsQuestionType);
        }
    };

    const checkForEmailValidationError = () => {
        let errorReason = false;
        const account =   _.get(submissionVM,'bindData');
        if(account.contactEmail.value === ' '){
            account.contactEmail.value = undefined;
            errorReason = true;
        }
        return errorReason;
    };

    const checkForSelfSurveyInfo = () => {
        clearBlockAlerts('missingSelfSurveyInfo');

        let missingInfo = false;

        if (bindData.value.homeInspectionDetails_Ext.inspectionTypeCode === "exterioronlyselfsurvey") {
            const account = _.get(submissionVM, 'bindData');

            if ((account.contactEmail?.value === undefined || account.contactEmail?.value === ' ') &&
                (primaryNamedInsuredVM.cellNumber?.value === undefined || primaryNamedInsuredVM.cellNumber?.value === '')) {
                missingInfo = true;
            }

            if (missingInfo) {
                addErrorAlert(translator(messages.homeSelfSurveyError), 'missingSelfSurveyInfo');
            }
        }

        return missingInfo;
    };

    const checkForEmail = () => {
        clearBlockAlerts('missingEmail');
        const eSignOption = submissionVM.bindData.esignature_ML.esignatureOptions?.value?.code === 'Email'
        let missingInfo = false;
        if (eSignOption) {
            if(_.isUndefined(submissionVM?.bindData?.contactEmail?.value)){
                missingInfo = true;   
            }
            if (missingInfo) {
                addErrorAlert(translator(messages.requiredFieldEmail), 'missingEmail');
            }
        }
        return missingInfo;
    }

    const checkForEsign = () => {
        clearBlockAlerts("missingEsign");
        clearBlockAlerts("missingEsignOption");
        clearBlockAlerts("missingMobileNumber");
        clearBlockAlerts("missingEmail");
        clearBlockAlerts("missingEsignAck")

        if (!isModernProduct || !isEsignEnabledForState) return false;

   
         let missingInfo = false;
   
         const eSign = _.get(
           submissionVM,
           "bindData.esignature_ML.esign_Ext.value",
         );
   
         const eSignOption = _.get(
           submissionVM,
           "bindData.esignature_ML.esignatureOptions.value.code",
         );
   
         const mobile = _.get(
           submissionVM,
           "bindData.esignature_ML.mobileNumber_Ext.value",
         );
   
         // esign is mandatory
         if (eSign == undefined || _.isUndefined(eSign)) {
           addErrorAlert(
             translator(messages.requiredFieldForEsign),
             "missingEsign",
           );
           missingInfo = true;
         }
   
         // eSignature Option is required when eSign = Yes
   
         if (eSign === true && !eSignOption) {
           addErrorAlert(
             translator(messages.requiredFieldForEsignOptions),
             "missingEsignOption",
           );
           missingInfo = true;
         }
   
         // Mobile is required when Text is selected
         if (eSignOption === "Text" && !mobile) {
           addErrorAlert(
             translator(messages.requiredField),
             "missingMobileNumber",
           );
           missingInfo = true;
         }

        //Acknowledgement is required when Text is selected
        if(eSign === true && eSignOption === 'Text'){
            const esignAck = _.get(submissionVM, `bindData.esignature_ML.esignTextAck_Ext.value`);
            if (_.isUndefined(esignAck) || esignAck == undefined) {
                addErrorAlert(
                    translator(messages.requiredFieldEsignAck),
                    "missingEsignAck",
                );
                missingInfo = true;
            }
        }
   
         return missingInfo;
       };

    const updateInspectionMethod = (value) => {
        setSelectedInspectionMethodCode(value.code)

        if (value.code === 'exterioronlyonsite') {
            setInspection({
                ...inspection,
                inspectionTypeCode: value.code,
                type: "Exterior-Only Onsite"
            });
            bindData.value.homeInspectionDetails_Ext.inspectionTypeCode = value.code
            bindData.value.homeInspectionDetails_Ext.propCommGated = "no"
        } else if (value.code === 'exterioronlyselfsurvey') {
            setInspection({
                ...inspection,
                inspectionTypeCode: value.code,
                type: "Exterior-Only Self-Survey"
            });
            bindData.value.homeInspectionDetails_Ext.inspectionTypeCode = value.code
            bindData.value.homeInspectionDetails_Ext.propCommGated = undefined
            bindData.value.homeInspectionDetails_Ext.propertyDirections = undefined
        }
    };

    const updateInspectionGated = (value) => {
        setInspection({
            ...inspection,
            propCommGated: value.code
        });
        bindData.value.homeInspectionDetails_Ext.propCommGated = value.code
    };

    const onOpenInspectionPopUp = () => {

        const componentProps = {
            showHeader: false,
            uiProps: MLInspectionKeyRemindersMetadata.pageContent,
            actionBtnLabel: "OK",
            CustomComponent: MLInspectionKeyRemindersModal,
            overrideProps: {
                viewModelService,
                authHeader,
                inspectionType: inspection.type || ''
            },
            buttonType: 'outlined'
        };
        
        try {
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        } catch (error) {
            console.error('Error opening inspection modal:', error);
    }
    };

    const setDefaultManualPolicyNumber = () => {
           const lineModifiers = _.get(
             submissionVM,
             "lobData.homeowners.modifiers_ML.lineModifiers_ML.value",
             [],
           );
    
           lineModifiers?.forEach((modifier) => {
             const isPolicyNumberModifier = multipolicyLobCodes.includes(
               modifier.codeIdentifier_ML,
             );
    
             const isEmpty =
               modifier.chosenTermValue === undefined ||
               modifier.chosenTermValue === null ||
               String(modifier.chosenTermValue).trim() === "";
    
             if (isPolicyNumberModifier && isEmpty) {
               modifier.chosenTermValue = "ManualMPD";
               modifier.isInputValueRequired_ML = false;
               modifier.savedFromPortal = true;
               modifier.updated = true;
               modifier.editMode_ML = true;
             }
           });
    
           updateWizardData(submissionVM);
        };

    const onNext = useCallback(async () => {
        if (isGpa) {
            UserService.getCurrentUser(authHeader).then((user) => {
                HOTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Ho AdditionalInfo Prebind Page', action: 'Ho Additional Info Prebind Submitted'});
            });
        } else {
            HOTrackEvent('Issuance Step Submitted', false, submissionVM, null, { step: 'Ho AdditionalInfo Prebind Page', action: 'Ho Additional Info Prebind Submitted'}, true);
        }

        _.set(submissionVM, 'portalCurrentStep_ML.value', 'hoAddtlInfoToBuy');
        
        if (!isComponentValid) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);

            return false;
        }

        checkForEmailValidationError();

        if (checkForSelfSurveyInfo()) {
            window.scrollTo(0, 0);

            return false;
        }

        if(checkForEsign()){
            window.scrollTo(0, 0);

            return false;
        }

        if(checkForEmail()){
            window.scrollTo(0, 0);

            return false;
        }
        setDefaultManualPolicyNumber();
        const valid = submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;
        if (valid) {
            const canSkipSave = steps.some((step) => step.mlStepName === 'paymentDetails' && !!step.visited);
            if (!canSkipSave) {
                setIsUWIssuesPanelVisible(false);
                if (isCompRaterPolicy && (_.isUndefined(submissionVM.baseData.policyAddress.validateAddressStatus_ML.value)
                    || submissionVM.baseData.policyAddress.validateAddressStatus_ML.value === false)
                ) {
                    await MLAddressVerificationService.validateAddress(viewModelService, submissionVM.baseData.policyAddress,
                        submissionVM.baseData.productCode.value);
                    showProgressDialog(platformMessages.saveSubmission);
                    try {
                        const response = await LoadSaveService.updateQuotedSubmission(submissionVM.value, isGpa && authHeader);
                        submissionVM.value = response;
                        sortAdditionalInterests_Ext();

                        if (checkForHomeAdditionalInfoPreBindUwIssues()) {
                            return false;
                        }

                        if (!nextStepVisited()) {
                            return submissionVM;
                        }
                        goNext();
                    }
                    catch (error) {
                        clearBlockAlerts('invalidCoverage');
                        if (error.baseError && error.baseError.indexOf('Reduce Personal Liability coverage limits') > -1) {
                            addErrorAlert(translator(messages.personalLiablityError), 'invalidCoverage');
                        }
                    }
                    finally {
                        hideProgressDialog(platformMessages.saveSubmission);
                    }
                } else {
                    showProgressDialog(platformMessages.saveSubmission);
                    try {
                        const response = await LoadSaveService.updateQuotedSubmission(submissionVM.value, isGpa && authHeader);
                        submissionVM.value = response;
                        _.set(submissionVM, 'baseData.value.originalEmail', _.get(submissionVM, 'bindData.contactEmail.value'));
                        sortAdditionalInterests_Ext();
                        isContinueClickedRef.current = true;

                        if (checkForHomeAdditionalInfoPreBindUwIssues()) {
                            return false;
                        }

                        if (!nextStepVisited()) {
                            return submissionVM;
                        }
                        goNext();
                    }
                    catch (error) {
                        clearBlockAlerts('invalidCoverage');
                        if (error.baseError && error.baseError.indexOf('Reduce Personal Liability coverage limits') > -1) {
                            addErrorAlert(translator(messages.personalLiablityError), 'invalidCoverage');
                        }
                    }
                    finally {
                        hideProgressDialog(platformMessages.saveSubmission);
                    }
                }
            } else {
                if (checkForHomeAdditionalInfoPreBindUwIssues()) {
                    return false;
                }
                goNext();
            }
        } else {
            // addErrorAlert('TODO: Found invalid data', 'additionalInformationPreBindPage');
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [LoadSaveService, authHeader, errorTimestamp, goNext, isCompRaterPolicy, isGpa, showProgressDialog, submissionVM, viewModelService]);

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.weWillReviewYourPaymentDetailsNext}
                values={{
                    reviewYourPaymentDetails: (
                        <strong>{translator(messages.reviewYourPaymentDetails)}</strong>
                    )
                }}
            />
        );
    };

    const getGatewayDisplayName = () => {
        const displayName = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value.displayName', '');
        if (displayName.includes(",")) {
            const name = _.startCase(_.toLower(displayName.split(",")[0]));
            const suffix = displayName.split(",")[1];

            return `${name}, ${suffix}`;
        }
        return _.startCase(_.toLower(displayName));
    };

    const disableEmailField = () => {
        return (isGpa && !_.get(submissionVM, 'canEditCommunicationsFields_Ext.value') && _.get(submissionVM, 'baseData.value.originalEmail'));
    };

    const validateEmailAddress = (accountContactDetailsVm) => {
        const account = accountContactDetailsVm;
        let emailAddress1 =  _.get(account, 'contactEmail.value');
        if(emailAddress1){
            emailAddress1 = emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = EmailValidationService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(submissionVM, 'baseData.accountHolder.emailVerified_Ext.value', true);
                    _.set(account, 'contactEmail.value', emailAddress1);
                }
                else{
                    _.set(submissionVM, 'baseData.accountHolder.emailVerified_Ext.value', false);
                    _.set(account, 'contactEmail.value', emailAddress1 + ' ');
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'contactEmail.value', emailAddress1);
                _.set(submissionVM, 'baseData.accountHolder.emailVerified_Ext.value', false);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }

    };

    const emailTrim = ( event ) => {
        let emailAddress1 =  event.target.value;
        if(emailAddress1 !== "" && emailAddress1 !== undefined){
            emailAddress1 = emailAddress1.trim();
            event.target.value = emailAddress1;
        }
    }

    const handleOnBlur = () => {
        const account = _.get(submissionVM,'bindData');
        validateEmailAddress(account);
    }
    const overrideProps = {
        additionalInterestList: {
            model: additionalInterests,
            addressVM,
            updateViewModel: updateSubmissionVM,
            onValueChange: writeValue,
            path: HO_ADDITIONAL_INTERESTS_PATH,
            initialPotentialContact: potentialContacts,
            showValidationErrors: showErrors,
            onValidate,
            isHOLine: true,
            isRenters,
            coveragePartTypeML,         
            potentialContactsLoading,
            additionalInterestAvailableCandidatesML,
            submissionVM
        },
        addressDetailsSection: {
            visible: !isGpa && isCompRaterPolicy
        },
        addressDetailsComponent: {
            addressVM: addressVM,
            onModelChange: updateAddressVM,
            layout: 'ml-policy-change',
            onValidate: onValidate,
            showValidationErrors: showErrors
        },
        phoneNumberSection: {
            visible: !isGpa && isCompRaterPolicy
        },
        phoneNumberComponent: {
            contactVM: primaryNamedInsuredVM,
            onModelChange: updateSubmissionVM,
            id: 'AddtionalInformationPreBindPage',
            showValidationErrors: showErrors
        },
        animalsSection: {
            visible: !isModernProduct && !isLandLord
        },
        selectAnimalHeader: {
            visible: isModernProduct 
        },
        dwellingQuestionSet: {
            value: filteredDwellingInfoQuestionSetData,
            onValueChange: onDwellingInfoValueChange,
            onBlur,
            onValidate,
            showErrors
        },
        emailH2: {
            visible: !isGpa,
            content: _.startCase(primaryNamedInsuredName)
        },
        nextDescription: {
            content: getNextStepText()
        },
        pageContainer: {
            className: isGpa && 'page-content-gpa'
        },
        stickyContinueSection: {
            visible: isGpa,
            defaultContinueSectionId: 'footer',
            onNext
        },
        modifierComponent: {
                    modifier: hoModifiers.lineModifiers_ML,
                    updateModifier: updateAdditionalInfoPrebindModifier,
                    onValidate: onValidate,
                    showValidationErrors: showErrors,
                    visible: !_.isUndefined(hoModifiers) && isModernProductHO,
                    showPopover: false,
                    submissionVM,
                    updateWizardData,
                    handleOnChange: true,
                    isAdditionalInfoPrebind: true          
        },
        gatewayDisplayName: {
            visible: isGpa,
            content: getGatewayDisplayName()
        },
        emailAddress: {
            placeholder: isGpa ? translator(messages.enterEmailAddress) : translator(messages.emailAddress),
            disabled: disableEmailField(),
            onBlur:handleOnBlur,
            onFocus: emailTrim
        },
        emailP: {
            visible: isQnB ? !isQnB : !isGpa
        },
        emailScriptColContainer: {
            visible: false
        },
        mlScriptComponent: {
            visible: isGpa,
            mlScript: scriptML
        },
        uwIssueContainer: {
            visible: isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: submissionVM.quoteID.value,
            publicID: _.get(submissionVM, 'value.publicID'),
            afterIssuesRefreshedCallback: checkForDisableNextButton,
            submissionVM,
            history
        },
        inspectionRequiredMessage: {
            visible: inspection.type !== null && inspection.type !== undefined
        },
        inspectionNotRequiredMessage: {
            visible: inspection.type === null || inspection.type === undefined
        },
        inspectionTypeLink: {
            content: inspection.inspectionHelp,
            onClick: onOpenInspectionPopUp
        },
        inspectionMethodPreferredContainer: {
            visible: inspection.inspectionHelp === "Exterior Only",
            className: isQnB ? "vertical-spacing-20 radioButtonQnB" : "vertical-spacing-20"
        },
        inspectionMethodPreferred: {
            onValueChange: updateInspectionMethod,
            value: {
                code: bindData.value.homeInspectionDetails_Ext.inspectionTypeCode
            }
        },
        inspectionGated: {
            onValueChange: updateInspectionGated,
            value: {
                code: bindData.value.homeInspectionDetails_Ext.propCommGated
            }
        },
        inspectionGatedContainer: {
            visible: inspection.type !== null && inspection.type !== undefined && selectedInspectionMethodCode !== 'exterioronlyselfsurvey',
            className: isQnB ? "vertical-spacing-20 radioButtonQnB" : "vertical-spacing-20"
        },
        inspectionProvideDirectionsContainer: {
            visible: inspection.type !== null && inspection.type !== undefined && selectedInspectionMethodCode !== 'exterioronlyselfsurvey'
        },
         esignContainer: {
            visible: isModernProduct && isEsignEnabledForState,
            model: submissionVM,
            updateWizardData,
            product: "homeowners"
        },
    };

    const resolvers = {
        resolveComponentMap: {
            mladdressdetailscomponent: MLAddressDetailsComponent,
            phoneNumberComponent: MLPhoneNumberComponent,
            questionset: QuestionSetComponent,
            mlScriptComponent: MLScriptComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent,
            esignatureComponent: EsignatureComponent,
            modifiercomponent: MLModifierComponent
        },
        resolveCallbackMap: {
            updateInspectionMethod,
            onNext: onNext
        }
    };

    const skipOnResumeIf = () => {
        // Skip to Confirmation Page for policy with a policy number
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        return isGpa && submissionVM.isBundle_ML.value && submissionVM.baseData.status_ML.value !== 'Draft' &&
            MLMultiLobsDataHolderService.isBeforeLastPurchaseFlowStepVisited('hoAddtlInfoToBuy', submissionVM.value);
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            disableNext={disableNextButton}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={getNextStepText()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyContinueSection'
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                showErrors={showErrors}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

HOAdditionalInformationPreBindPage.propTypes = wizardProps;
export default withRouter(HOAdditionalInformationPreBindPage);
